<ng-container *ngIf="user">
    <div class="AccountWarning">
        <div class="Wrap">
            <div class="Content">
                <div class="Alert-container" *ngIf="user.accountWarningType">
                    <ng-container *ngIf="user?.accountWarningType === 'SUBSCRIPTION_INCOMPLETE_TIMER'; else subscriptionIncomplete">
                        <div [className]="user.daysBeforeSubscriptionExpires > 7 ? 'Alert Alert--yellow' : 'Alert Alert--red'">
                            <p>
                                <b>{{('uishared.accountWarningType.'+user.accountWarningType+'.label') | transloco }}</b>
                                {{('uishared.accountWarningType.'+user.accountWarningType+'.message') | transloco: { numberOfDays : user.daysBeforeSubscriptionExpires } }}
                            </p>
                        </div>      
                    </ng-container>
                    <ng-template #subscriptionIncomplete>
                        <div class="Alert Alert--blue">
                            <p>
                                <b>{{('uishared.accountWarningType.'+user.accountWarningType+'.label') | transloco }}</b>
                                {{('uishared.accountWarningType.'+user.accountWarningType+'.message') | transloco}}
                            </p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-container>